export enum UserStatus {
    OFFLINE = "offline",
    IDLE = "idle",
    ACTIVE = "active",
    SILENT = "silent",
    IN_CALL = "inCall",
    INACTIVE = "inactive",
}

export const SELECTABLE_USER_STATUSES = [UserStatus.IDLE, UserStatus.ACTIVE, UserStatus.SILENT] as const;

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
    [UserStatus.OFFLINE]: "Offline",
    [UserStatus.IDLE]: "Idle",
    [UserStatus.ACTIVE]: "Active",
    [UserStatus.SILENT]: "Silent",
    [UserStatus.IN_CALL]: "In Call",
    [UserStatus.INACTIVE]: "Inactive",
};
